<template>
  <!-- 我的跟进：3 个 tab（我负责的 / 我参与的 / 我下属参与的），口径按「客户」归属过滤 -->
  <FollowUpList :show-create="true" :show-tabs="true" />
</template>

<script lang="ts" setup>
import FollowUpList from '../components/FollowUpList.vue'

defineOptions({ name: 'CrmFollowUpMy' })
</script>
